/**
 * bootDiag — persistente Spur für alles, was zum Login-Bildschirm führt.
 *
 * Warum überhaupt: Der Produktionsbuild minifiziert mit Terser und hat lange
 * JEDEN console-Kanal entfernt (drop_console + pure_funcs inkl. warn/error).
 * Auf prod war damit nicht feststellbar, WARUM ein Refresh auf der Loginseite
 * endet — die drei Pfade dorthin (Router-Guard, 'newloginrequired',
 * 'renewtokenrequired') sehen von außen identisch aus.
 *
 * Konsolenausgabe allein reicht als Ersatz nicht: Wer den Rauswurf meldet,
 * hatte die Konsole beim Auftreten meist nicht offen. Deshalb ein Ringpuffer in
 * localStorage — er überlebt Reload und Redirect und ist über DevTools →
 * Application → Local Storage ablesbar, ohne dass irgendetwas mitgeschnitten
 * werden musste.
 *
 * Auslesen (Konsole, funktioniert auch im Prod-Build):
 *   JSON.parse(localStorage.getItem('mycrogym_boot_diag'))
 *
 * Es werden ausschließlich Ereignisnamen und Fehlermeldungen abgelegt — keine
 * Tokens, keine Passwörter, keine Personendaten.
 */

const KEY = 'mycrogym_boot_diag'
const MAX_ENTRIES = 30

export interface BootDiagEntry {
  t: string       // ISO-Zeitstempel
  ev: string      // Ereignisname, z.B. 'authcheck.failed'
  d?: string      // Detail (Fehlermeldung / Kurzinfo)
}

/**
 * Hängt ein Ereignis an den Ringpuffer.
 *
 * Schluckt eigene Fehler bewusst: In Safaris privatem Modus wirft
 * localStorage.setItem, und ein Diagnosewerkzeug darf den Startvorgang, den es
 * beobachtet, unter keinen Umständen zum Absturz bringen.
 */
export function bootDiag(ev: string, detail?: unknown): void {
  const entry: BootDiagEntry = { t: new Date().toISOString(), ev }
  if (detail !== undefined && detail !== null) {
    const err = detail as any
    entry.d = String(err?.message ?? err).slice(0, 300)
  }
  // Immer auch auf die Konsole — im Prod-Build bleibt console.warn erhalten.
  console.warn('[bootDiag]', ev, entry.d ?? '')
  try {
    const raw = localStorage.getItem(KEY)
    const list: BootDiagEntry[] = raw ? JSON.parse(raw) : []
    list.push(entry)
    localStorage.setItem(KEY, JSON.stringify(list.slice(-MAX_ENTRIES)))
  } catch {
    /* Speicher nicht verfügbar — die Konsolenzeile oben bleibt */
  }
}

/** Kompletter Puffer, z.B. für einen Support-Export. */
export function readBootDiag(): BootDiagEntry[] {
  try {
    const raw = localStorage.getItem(KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

export default bootDiag
